const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const FormatCurrency = (value) => {
  if (formatter.format(value) === "$NaN") {
    return formatter.format(0);
  }
  return formatter.format(value);
};

const CurrencyType = ({ value }) => {
  return FormatCurrency(value);
};

export default CurrencyType;
